<template>
<div>
     <div class="navbar">
            <img width="50" height="50" src="../../static/assets/img/icon.png" />
            <div style="font-size:x-large;margin-left: 5%;width: 62%;">塔兮App</div>
        </div>
        <el-empty description="该页面不存在"></el-empty>

</div>
</template>

<script>
export default {
    name:'NotFound'
}
</script>

<style scoped> 
.navbar{
    display: flex;
    margin: 3%;
    align-items:center;

}
</style>


// WEBPACK FOOTER //
// src/views/NotFound.vue